import { takeLatest } from 'redux-saga/effects';
import { SEND_POLL_ANSWER } from '../../reducers';
import { sendPollAnswer } from './sendPollAnswer';

export function* disableFormsSagas() {
  yield takeLatest(SEND_POLL_ANSWER, sendPollAnswer);
}
